console.log('PDP Add-On Upsell script loaded');

// simple money formatter       
function formatMoney(cents) {
  // Ensure it's a number
  const value = (cents / 100).toFixed(2);
  return `$${value}`;
}

// Updates upsell data on variant change
window.addEventListener('variant-change', (event) => {
  console.log('Variant change event detected');

  // get upsell metafield for the current variant
  const variant = event.detail.variant;
  const metafields = window.theme?.productSellsMetafields?.productMetafields?.variantMetafields || [];
  const found = metafields.find(v => v.variant_id == variant.id);
  const upsellMetafield = found?.closet_add_ons || [];

  // Remove old upsell if it exists
  document.querySelector('#complete-the-look-wrapper-upsell')?.remove();

  // Only render if metafields exist and have content
  if (!upsellMetafield.length) {
    console.log('No upsell metafields for this variant');
    return;
  }

  // get product title
  const productTitle = document.querySelector('.product-single__title')?.textContent.trim() || '';

  // create upsell section
  const wrapper = document.createElement('div');
  wrapper.id = 'complete-the-look-wrapper-upsell';
  wrapper.className = 'complete-the-look-wrapper';
  wrapper.innerHTML = `
     <div class="complete-the-look upsell">
      <div class="title-container">
        <div class="accordion__heading title">${productTitle || 'Tower'} Add-ons</div>

      </div>
      <div class="complete-the-look-products complete-the-look-products-upsell">
        ${upsellMetafield.map(item => `
          <a href="/products/${item.product.handle}?variant=${item.variant.id}" target="_blank" rel="noopener noreferrer" class="upsell-products-container">
            <div class="upsell-product-wrapper">
              <div class="upsell-product">
                <div class="upsell-product_image-wrapper">
                  <img src="${item.variant.featured_image?.src || ''}" />
                </div>
                <div class="upsell-product_info-button-wrapper">
                  <div class="upsell-product_info">
                    <p class="upsell-product_title">${item.product.title || ''}</p>
                    <p class="upsell-product_variant_title">${item.variant.title || ''}</p>
                    <p class="upsell-product_price">${formatMoney(item.variant.price)}</p>
                  </div>
                  <component-addtocart data-handle="${item.product.handle}">
                    <form action="/cart/add" method="post">
                      <input type="hidden" name="id" value="${item.variant.id}">
                      <input type="hidden" name="quantity" value="1">
                      <input type="hidden" name="properties[tag_value]" value="upsell-pdp">
                      <button class="upsell-product_add-to-cart-button" type="submit" name="add">
                        <span>Add to cart</span>
                      </button>
                    </form>
                  </component-addtocart>
                </div>
              </div>
            </div>
          </a>
        `).join('')}
      </div>
    </div>
  `;

  // append to the product details container
  const productDetailsSection = document.querySelector('.product-single__details-wrapper');
  productDetailsSection?.after(wrapper);
});